//
// WARNING this file is automatically generated by release-gem
//

export const APP_VERSION = "6.12.2";

export const APP_TIMESTAMP = "1762366363";

